import LaptopHeader from './LaptopHeader';
import MobileHead from './MobileHeader';

const MainHeader = () => {
  return (
    <>
      <MobileHead />
      <LaptopHeader />
    </>
  );
};

export default MainHeader;
